import { createRouter, createWebHistory } from 'vue-router'

export const router = new createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: {},
    },
  ],
})
